import classNames from 'classnames';

export type InputVariant = 'default' | 'white';

export type InputHeight = 'md' | 'sm';

export type InputClassProps = {
  variant?: InputVariant;
  disabled?: boolean;
  hasError?: boolean;
  fullWidth?: boolean;
  height?: InputHeight;
  isPlaceholder?: boolean;
};

export const getInputClassName = ({
  variant = 'default',
  disabled,
  hasError,
  fullWidth,
  height = 'md',
  isPlaceholder,
}: InputClassProps) =>
  classNames(
    'appearance-none border rounded focus:outline-none placeholder-primary-300',
    {
      'py-1 px-2 text-sm': height === 'sm',
      'py-3 px-4 text-base': height === 'md',
      'bg-primary-25': variant === 'default',
      'bg-white': variant === 'white',
      'text-primary-300': isPlaceholder,
      'text-primary-400': disabled,
      'text-primary-500': !disabled && !isPlaceholder,
      'w-full': fullWidth,
      'border-red-500 focus:ring-1 focus:ring-red-500': hasError,
      'border-primary-150 focus:shadow-primary-500': !hasError,
    }
  );
